import RectangularSkeleton from "@shared/components/skeleton/RectangleSkeleton";
import { FC } from "react";
import { InstructorSkeletonItem } from "./InstructorSkeletonItem";
import InstructorsProductsSkeleton from "./InstructorsProductsSkeleton";

const SkeletonInstructor: FC = () => {
  return (
    <div>
      <RectangularSkeleton
        width={"100%"}
        height={58}
        className="w-full fds-l:hidden"
      />
      <div className="fds-l:fds-container pt-6  w-full px-4 fds-l:flex gap-x-6">
        {/* Left side (main instructor detail card) */}
        <div className="detailInstructor grow shrink-0 w-full border-fds-cart border rounded-10 fds-l:px-0 fds-l:py-6">
          <div className="fds-l:flex fds-l:pb-6  fds-l:px-4     fds-l:flex-row relative w-full rounded-10 fds-l:rounded-0 flex-col items-start fds-l:items-center">
            {/* Background image skeleton */}
            <div className="w-full rounded-t-10 h-[150px] overflow-hidden fds-l:hidden relative aspect-[4/1]">
              <RectangularSkeleton
                width={"100%"}
                height={"100%"}
                className="w-full h-full"
              />
            </div>

            {/* Instructor image */}
            <div className="relative block fds-l:hidden aspect-square instructorPic w-[120px]">
              <RectangularSkeleton
                width={"100%"}
                height={"100%"}
                className="w-full h-full rounded-full"
              />
            </div>
            <div className="relative hidden fds-l:block aspect-square instructorPic fds-l:w-[140px]">
              <RectangularSkeleton
                width={"100%"}
                height={"100%"}
                className="w-full h-full rounded-full"
              />
            </div>

            {/* Name + Field */}
            <div className="flex flex-col px-3 fds-l:px-4 fds-sm:py-5 fds-l:py-0 mt-3">
              <RectangularSkeleton
                height={24}
                width={160}
                className=" mb-2 rounded"
              />
              <RectangularSkeleton
                height={16}
                width={128}
                className=" mb-2 rounded"
              />
              <RectangularSkeleton
                height={16}
                width={96}
                className=" rounded"
              />
            </div>
          </div>

          {/* Status section */}
          <div className="px-4 py-3 border-t h-[100px] w-full hidden fds-l:block">
            <RectangularSkeleton
              height="100%"
              width="100%"
              className=" rounded"
            />
          </div>
          <div className="px-4 py-3 border-t h-[160px] w-full fds-l:hidden">
            <RectangularSkeleton
              height="100%"
              width="100%"
              className=" rounded"
            />
          </div>
          <div className="hidden fds-l:block">
            <InstructorsProductsSkeleton />
          </div>
        </div>

        <div className="w-full fds-l:block hidden border border-fds-cart rounded-8 h-max">
          {Array(4)
            .fill("")
            .map((_, idx) => (
              <InstructorSkeletonItem key={idx} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default SkeletonInstructor;
